import classnames from "classnames";
import "./badge.scss";

export const badgeColors = {
    PRIMARY: "",
    RED: "red",
    BLACK: "black",
    AMBER: "amber",
};

export const Badge = ({ children, size, color, badgeContent }) => {
    return (
        <div className="badge-container">
            <div className={classnames("badge", size ? `-${size}` : "", color)}>{badgeContent}</div>
            {children}
        </div>
    );
};
